<template>
  <div class="mark">
    <div class="markItem">减弱</div>
    <div class="markItem">普通</div>
    <div class="markItem">加强</div>
    <div
      :class="
        item.status == '减弱'
          ? 'markIcon'
          : item.status == '普通'
          ? 'markIcon markIconPh'
          : 'markIcon markIconjq'
      "
    >
      <span>{{ item.value }}</span>
      <img :src="colorsImg[lev]" />
    </div>
  </div>
</template>
<script>
export default {
  props: ['item'],
  data () {
    return {
      lev: 0,
      colorsImg: [
        require('../../../assets/image/chang/jiantou1.png'),
        require('../../../assets/image/chang/jiantou2.png'),
        require('../../../assets/image/chang/jiantou3.png'),
      ],
    }
  },
  watch: {
    item (newVal) {
    }
  },
  created () {
    this.keyLr()
  },
  methods: {
    keyLr () {
      switch (this.item.status) {
        case '减弱':
          this.lev = 0
          break
        case '普通':
          this.lev = 1
          break
        case '加强':
          this.lev = 2
          break
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.mark {
  width: 100%;
  margin: 90px auto 0px auto;
  position: relative;
  height: 80px;

  .markIcon {
    position: absolute;
    width: 33.3333%;
    text-align: center;
    color: #3195e6;
    bottom: 65px;
    img {
      width: 40px;
      height: 53px;
    }
    span {
      display: inline-block;
      width: 100%;
      font-size: 28px;
    }
  }
  .markIconPh {
    color: #9ef133;
    left: 33.3333%;
  }
  .markIconjq {
    color: #f1be33;
    left: 66.6666%;
  }
  .markItem {
    width: 33.3333%;
    display: inline-block;
    position: relative;
    float: left;
    text-align: center;
    font-size: 28px;
  }
  .markItem::before {
    content: "";
    width: 100%;
    height: 30px;
    background: #000;
    position: absolute;
    left: 0;
    top: -40px;
  }
  .markItem:nth-child(1) {
    color: #3195e6;
  }
  .markItem:nth-child(2) {
    color: #9ef133;
  }
  .markItem:nth-child(3) {
    color: #f1be33;
  }
  .markItem:nth-child(1):before {
    background: #3195e6;
    color: #3195e6;
  }
  .markItem:nth-child(2):before {
    background: #9ef133;
    color: #9ef133;
  }
  .markItem:nth-child(3):before {
    background: #f1be33;
    color: #f1be33;
  }
}
</style>